import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import { withFirebase } from '../auth/firebase/context';

class PasswordResetFormBase extends Component {

    constructor(props) {
        super(props);
        this.state = {
            email: '',
            error: null
        }
    }

    onSubmit = event => {
        const { email } = this.state;
        const { firebase } = this.props;

        firebase
            .passwordReset(email)
            .then(() => {
                this.setState({
                    email: '',
                    error: null
                });
                this.props.history.push('/');
            })
            .catch(error => {
                this.setState({ error });
            });
        event.preventDefault();
    };

    onChange = event => {
        this.setState({[event.target.name]: event.target.value});
    };

    render() {
        const { email, error } = this.state;

        const isInvalid = email.length <= 0;
        return (
            <form onSubmit={this.onSubmit}>
                <input 
                    name="email"
                    value={this.state.email}
                    onChange={this.onChange}
                    type="text"
                    placeholder="Email Address"
                />
                <button disabled={isInvalid} type="submit">
                    Reset my password
                </button>

                {error && <p>{error.message}</p>}

            </form>
        )
    }
}

export default withRouter(withFirebase(PasswordResetFormBase));